import { ContractStatus } from '../../../types/entities'

export const contractStatusLabel = (status: ContractStatus): string => {
  const labels: Record<ContractStatus, string> = {
    active: 'Ativo',
    expired: 'Expirado',
    pending: 'Pendente',
  }
  return labels[status]
}

export const contractStatusSeverity = (status: ContractStatus): 'success' | 'danger' | 'warning' => {
  const map: Record<ContractStatus, 'success' | 'danger' | 'warning'> = {
    active: 'success',
    expired: 'danger',
    pending: 'warning',
  }
  return map[status]
}
